import { api } from '../../client';

export interface EmployeeLeaveRequestDto {
  id: string;
  leave_credit_id: string;
  employee_leave_credit_id: string | null;
  date_from: string;
  date_to: string;
  reason: string;
  status: string;
  created_at?: string;
  updated_at?: string;
}

export const employeeLeaveRequestsApi = {
  async list(): Promise<{ data?: EmployeeLeaveRequestDto[]; message?: string }> {
    return api.get('/employee/leave-requests') as Promise<{ data: EmployeeLeaveRequestDto[] }>;
  },

  async create(data: {
    leave_credit_id: string;
    date_from: string;
    date_to: string;
    reason: string;
  }): Promise<{ data?: EmployeeLeaveRequestDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/employee/leave-requests', data) as Promise<{
      data: EmployeeLeaveRequestDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },
};
